import Success from '@/app/features/Success/Success.vue';

import { ENavigationGuardTypes, ECheckoutStep, EOrderSuccessPages } from '@/helpers/enums';

export default [
  {
    name: EOrderSuccessPages.orderConfirmed,
    path: '/:slug/pedido-confirmado/:order_id',
    component: Success,
    meta: {
      checkoutStep: ECheckoutStep.confirmation,
      navigationGuardType: ENavigationGuardTypes.private,
    },
  },
  {
    name: EOrderSuccessPages.orderWaitingPayment,
    path: '/:slug/pedido-aguardando-pagamento/:order_id',
    component: Success,
    meta: {
      checkoutStep: ECheckoutStep.confirmation,
      navigationGuardType: ENavigationGuardTypes.private,
    },
  },
  {
    name: EOrderSuccessPages.renewConfirmed,
    path: '/:contract_id/contrato-renovado',
    component: Success,
    meta: {
      checkoutStep: ECheckoutStep.confirmation,
      navigationGuardType: ENavigationGuardTypes.private,
    },
  },
  {
    name: EOrderSuccessPages.renewWaitingPayment,
    path: '/:contract_id/renovacao-aguardando-pagamento',
    component: Success,
    meta: {
      checkoutStep: ECheckoutStep.confirmation,
      navigationGuardType: ENavigationGuardTypes.private,
    },
  },
];
